import {
    Injectable,
} from '@angular/core';

import {
    NgbModal
} from '@ng-bootstrap/ng-bootstrap';

import { WorkflowAuditReportComponent } from '../components/workflow-audit-report/workflow-audit-report.component';

/*
* Service to view the audit-report modal.
*/
@Injectable()
export class ViewWorkflowAuditReportComponentService {

    readonly EMPTY_RESULT: any[] = [];

    constructor(
        private modalService: NgbModal
    ) {
        //
    }

    openComponent(taskInstanceKey: number) {
        const modalRef = this.modalService.open(WorkflowAuditReportComponent, { size: 'lg' });
        modalRef.componentInstance.taskInstanceKey = taskInstanceKey;
    }
}
